import { Dropdown, cn } from '@utima/ui';
import { Info, type LucideIcon } from 'lucide-react';
import { memo, type ReactNode, type SyntheticEvent } from 'react';

import { SimpleTooltip } from '@/components/tooltips/simple-tooltip';

const stopMenuEvent = (event: SyntheticEvent) => {
  event.stopPropagation();
};

export type DropdownIconMenuItemProps = {
  icon: LucideIcon;
  label: ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  disabledTooltip?: string;
  hint?: string;
  className?: string;
};

export const DropdownIconMenuItem = memo(function DropdownIconMenuItem({
  icon: Icon,
  label,
  onClick,
  disabled = false,
  disabledTooltip,
  hint,
  className,
}: DropdownIconMenuItemProps) {
  const itemClassName = cn('flex items-center justify-start gap-2', className);

  const menuItem = (
    <Dropdown.Item
      className={cn(itemClassName, disabled && 'opacity-50')}
      disabled={disabled}
      onClick={event => {
        event.stopPropagation();

        if (!disabled) {
          onClick?.();
        }
      }}
    >
      <Icon className='size-4 shrink-0' />
      {label}
      {hint && (
        <SimpleTooltip title={hint}>
          <span
            className='inline-flex shrink-0'
            onClick={stopMenuEvent}
            onPointerDown={stopMenuEvent}
          >
            <Info className='size-3.5 cursor-help text-muted-fg' />
          </span>
        </SimpleTooltip>
      )}
    </Dropdown.Item>
  );

  if (disabled && disabledTooltip) {
    return (
      <SimpleTooltip title={disabledTooltip}>
        <span className='block'>{menuItem}</span>
      </SimpleTooltip>
    );
  }

  return menuItem;
});
